import { CredentialType } from '@common/types/keycloak';
import { KeycloakUserResponses } from '@common/types/user';
import { api } from '@services/api';

const keycloakApi = api.injectEndpoints({
    endpoints: (builder) => ({
        migrateUser: builder.mutation<void, { password: string }>({
            query: (body) => ({ url: 'keycloak/user/migrate/', method: 'POST', body }),
        }),
        getTwoFARoles: builder.query<{ name: string }[], void>({
            query: () => 'public/keycloak/2fa-roles/',
            providesTags: ['TwoFARoles'],
        }),
        checkEmail: builder.query<{ check_status: KeycloakUserResponses }, string>({
            query: (email: string) => `public/keycloak/user/check/${encodeURIComponent(email)}`,
            providesTags: (_res, _err, email) => [{ type: 'CheckEmail', id: email }],
        }),
        getKeycloakLoginUrl: builder.query<
            { login_url: string },
            { email: string; prompt_login?: boolean; locale?: string }
        >({
            query: ({ email, prompt_login, locale }) =>
                `public/keycloak/login/url/${encodeURIComponent(email)}?${prompt_login ? 'prompt_login=true&' : ''}${
                    locale ? `locale=${encodeURIComponent(locale)}` : ''
                }`,
            providesTags: ['KeycloakLoginUrl'],
        }),
        getUserCredentialTypes: builder.query<CredentialType[], void>({
            query: () => 'keycloak/user/credential/type/',
            providesTags: ['UserCredentialTypes'],
        }),
    }),
});

export const {
    useMigrateUserMutation,
    useGetTwoFARolesQuery,
    useCheckEmailQuery,
    useLazyCheckEmailQuery,
    useGetKeycloakLoginUrlQuery,
    useLazyGetKeycloakLoginUrlQuery,
    useGetUserCredentialTypesQuery,
} = keycloakApi;
export default keycloakApi;
